import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./OurWork.css";
import { ReactComponent as ArrowRight } from "../../assets/work/arrow-right.svg";
import API_BASE_URL from "../../config"; // 👈 import base URL
import { AnimatedButton } from "../common/AnimatedButton";
import { motion } from "framer-motion";

const OurWorkSectionHome = () => {
  const [projects, setProjects] = useState([]);
  const [loader, setloader] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE_URL}/work-projects`) // 👈 use dynamic URL
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched projects:", data);
        // setProjects(data.slice(0,4));
        setProjects(data);
      })
      .catch((err) => {
        console.error("Error fetching projects:", err);
      })
      .finally(() => setloader(false));
  }, []);

  // Separate projects by groups for wrappers
  const pillowAndGlamora = projects.filter((p) => p.id === 1 || p.id === 30);
  const singleAmora = projects.filter((p) => p.id === 31);
  const inspireAndDental = projects.filter((p) => p.id === 33 || p.id === 32);

  useEffect(() => {
    const cards = document.querySelectorAll(".ourwork-card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target); // animate once
          }
        });
      },
      {
        threshold: 0.2, // fire when 20% visible
      }
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, [projects]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <section className="ourwork-section">
        <h2 className="ourwork-heading">Our Work</h2>
        <p className="ourwork-subheading">
          A sneak peek into things, we've proudly built.
        </p>

        {loader ? (
          <div
            className="custom-loader1"
            style={{
              height: "65vh",
              width: "100vw",
              position: "relative",
              zIndex: "1",
            }}
          >
            <div className="dots-loader">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        ) : (
          // <div className="ourwork-row">
          //   {projects.map((project) => (
          //     <div
          //       className="ourwork-card"
          //       key={project.id}
          //       onLoad={(e) => e.currentTarget.classList.add("show")}
          //     >
          //       <img
          //         src={
          //           project?.poster_url ||
          //           "https://via.placeholder.com/280x200?text=No+Image"
          //           // project.image_url
          //           //   ? project.image_url.startsWith("http")
          //           //     ? project.image_url
          //           //     : `${process.env.PUBLIC_URL}/${project.image_url}`
          //           //   : "https://via.placeholder.com/280x200?text=No+Image"
          //         }
          //         alt={project.title}
          //         className="ourwork-image"
          //       />

          //       <h4 className="ourwork-title">{project.title}</h4>
          //       <p className="ourwork-subtitle">
          //         {project.subtitle.replace(/\s*–\s*/g, " | ")}
          //       </p>
          //     </div>
          //   ))}
          // </div>
          <section className="ourwork-section">
            <section className="just-timepass">
              {/* Pillow & Glamora */}
              {pillowAndGlamora.length > 0 && (
                <div className="pillowAndGlamora">
                  {pillowAndGlamora.map((p) => (
                    <Link
                      key={p.id}
                      to={`/worksub/${p.slug}`}
                      // className="ourwork-card"
                    >
                      <div className={p.id === 1 ? "pillow" : "glamora"}>
                        <img
                          src={p?.poster_url}
                          alt={p.title}
                          className={
                            p.id === 1
                              ? "ourwork-image-lux  animate from-left"
                              : "ourwork-image-glamora  animate from-right"
                          }
                          onLoad={(e) => {
                            e.currentTarget.classList.add("show");
                          }}
                        />
                        <h4 className="ourwork-title">{p.title}</h4>
                        <p className="ourwork-subtitle">{p.subtitle}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              )}

              {/* Single Amora */}
              {singleAmora.length > 0 &&
                singleAmora.map((p) => (
                  <Link
                    to={`/worksub/${p.slug}`}
                    key={p.id}
                    // className="ourwork-card"
                  >
                    <div className="amora">
                      <img
                        src={p.poster_url}
                        alt={p.title}
                        className="ourwork-image-amora animate from-bottom"
                        onLoad={(e) => e.currentTarget.classList.add("show")}
                      />
                      <h4 className="ourwork-title">{p.title}</h4>
                      <p className="ourwork-subtitle">{p.subtitle}</p>
                    </div>
                  </Link>
                ))}

              {/* Inspire & Dental */}
              {inspireAndDental.length > 0 && (
                <div className="inspireAndDental">
                  {inspireAndDental.map((p) => (
                    <Link
                      to={`/worksub/${p.slug}`}
                      key={p.id}
                      // className="ourwork-card"
                    >
                      <div className={p.id === 33 ? "amora" : "amora"}>
                        <img
                          src={p.poster_url}
                          alt={p.title}
                          className={
                            p.id === 33
                              ? "ourwork-image-amora animate from-left"
                              : "ourwork-image-dental  animate from-right"
                          }
                          onLoad={(e) => {
                            e.currentTarget.classList.add("show");
                          }}
                        />
                        <h4 className="ourwork-title">{p.title}</h4>
                        <p className="ourwork-subtitle">{p.subtitle}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </section>
          </section>
        )}

        <div className="viewall-button-container">
          {/* <Link to="/ourwork" className="viewall-button-rounded">
          <span className="button-text">View All</span>
          <span className="button-icon">
            <ArrowRight className="arrow-icon" />
          </span>
        </Link> */}
          <AnimatedButton link="ourwork" label="View All" />
        </div>
      </section>
    </motion.div>
  );
};

export default OurWorkSectionHome;
